import React, { useEffect, useMemo, useState } from "react";
import { Link, withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import uuid from "react-uuid";
import ApiService from "../../Services/apiService";
import AlertService from "../../Services/alertService";
import TranslationService from "../../Services/translationService";
import {
	addPartialViewSpinner,
	removePartialViewSpinner,
} from "../../Store/Actions/spinner";
import { ERROR_KEY, SUCCESS_KEY } from "../../Constants/mainKeys";
import ReactSelectOption from "../../Components/SelectOption/reactSelectOption";
import NoDataImage from "../../assets/images/illustrations/nodata.svg";
import PageInfoBlock from "../../Components/PageInfoBlock/PageInfoBlock";
import ViewSvg from './../../Components/Svg/viewSvg';
import EditSvg from './../../Components/Svg/editSvg';
import DeleteSvg from './../../Components/Svg/deleteSvg';
import DownloadSvg from './../../Components/Svg/downloadSvg';

const LS_SELECTED_CATEGORY_KEY = "met_documents_selected_category_id";

function DocumentsTable(props) {
	const dispatch = useDispatch();
	const { language } = useSelector(state => state.language);
	const translations = useSelector(state => state.translation.translations);
	const [translationService, setTranslationService] = useState(null);

	const [categories, setCategories] = useState([]);
	const [selectedCategoryId, setSelectedCategoryId] = useState(null);
	const [documents, setDocuments] = useState([]);

	useEffect(() => {
		setTranslationService(new TranslationService(translations));
	}, [translations]);

	useEffect(() => {
		getCategories();
		// restore last selected
		const saved = localStorage.getItem(LS_SELECTED_CATEGORY_KEY);
		if (saved !== null && saved !== undefined && saved !== "") {
			setSelectedCategoryId(Number(saved));
		}
	}, []);

	useEffect(() => {
		if (selectedCategoryId) {
			localStorage.setItem(LS_SELECTED_CATEGORY_KEY, String(selectedCategoryId));
			getDocumentsByCategory(selectedCategoryId);
		} else if (selectedCategoryId === null) {
			setDocuments([]);
		}
	}, [selectedCategoryId]);

	const categoryOptions = useMemo(() => {
		const other = { id: -1, name: translationService?.translate("TR_OTHER") || "TR_OTHER" };
		const list = Array.isArray(categories) ? [...categories] : [];
		return [...list, other].map(c => ({ ...c, value: c.id, label: c.name }));
	}, [categories, translationService]);

	const getCategories = () => {
		const spinnerId = uuid();
		dispatch(addPartialViewSpinner(spinnerId));
		ApiService.getDocumentCategory()
			.then(res => {
				if (res && res.data) {
					setCategories(res.data);
				}
			})
			.catch(err => {
				AlertService.alert(
					AlertService.checkMessageType(err?.respcode) || ERROR_KEY,
					err,
				);
			})
			.finally(() => {
				dispatch(removePartialViewSpinner(spinnerId));
			});
	};

	const getDocumentsByCategory = categoryId => {
		const spinnerId = uuid();
		dispatch(addPartialViewSpinner(spinnerId));
		ApiService.getOrganizationDocument(categoryId)
			.then(res => {
				if (res && res.data) {
					setDocuments(res.data);
				} else {
					setDocuments([]);
				}
			})
			.catch(err => {
				AlertService.alert(
					AlertService.checkMessageType(err?.respcode) || ERROR_KEY,
					err,
				);
			})
			.finally(() => {
				dispatch(removePartialViewSpinner(spinnerId));
			});
	};

	const onDelete = doc => {
		if (!doc?.id) return;
		AlertService.alertConfirm(
			translationService?.translate("TR_ARE_YOU_SURE_MODAL") || "Are you sure?",
			"",
			translationService?.translate("TR_YES") || "Yes",
			translationService?.translate("TR_NO") || "No",
		).then(() => {
			const spinnerId = uuid();
			dispatch(addPartialViewSpinner(spinnerId));
			ApiService.deleteDocument(doc.id)
				.then(() => {
					setDocuments(prev => prev.filter(d => d.id !== doc.id));
					AlertService.alert(
						SUCCESS_KEY,
						translationService?.translate("TR_DATA_SAVED") || "Saved",
					);
				})
				.catch(err => {
					AlertService.alert(
						AlertService.checkMessageType(err?.respcode) || ERROR_KEY,
						err,
					);
				})
				.finally(() => dispatch(removePartialViewSpinner(spinnerId)));
		});
	};

	if (!translationService) return null;

	return (
		<div className="container mt-4">
			{/* <div className="row">
				<div className="col-12 d-flex justify-content-between align-items-center">
					<h2 className="section-title mb-0">
						{translationService.translate("TR_DOCUMENTS") || "Documents"}
					</h2>

				</div>
			</div> */}
			<div className="row">
				<div className="col-12">
					<h2 className="section-title">
						{translationService.translate("TR_DOCUMENTS")}
					</h2>
					<PageInfoBlock
						pageTitle="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
						infoText="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
						translationService={translationService}
					/>
				</div>
			</div>
			<hr />
			<div className="row align-items-end">
				<div className="col-12">
					<div className="d-flex justify-content-end">
						<Link
							to={`/${language}/document/document-form`}
							className="mindalay--btn-default">
							{translationService.translate("TR_CREATE_DOCUMENT") || "Create"}
						</Link>
					</div>
				</div>
			</div>
			<hr />
			<div className="row">
				<div className="col-12 col-md-6">
					<div className="form-group">
						<label>{translationService.translate("TR_DOCUMENT_TYPE") || "Type"}</label>
						<ReactSelectOption
							placeholder={translationService.translate("TR_CHOOSE") || "Choose"}
							selectedValue={(() => {
								const found = categoryOptions.find(c => c.id === selectedCategoryId);
								return found ? { ...found, value: found.id, label: found.name } : null;
							})()}
							items={categoryOptions.filter(c => c.id !== selectedCategoryId)}
							onChange={item => {
								if (!item) return;
								if (item.id === -1) {
									// "Other" acts like go-to file library in Angular; for now just clear filter
									setSelectedCategoryId(null);
									setDocuments([]);
									return;
								}
								setSelectedCategoryId(item.id);
							}}
						/>
					</div>
				</div>

			</div>

			{documents && documents.length ? (
				<div className="row mt-2">
					<div className="col-12">
						<div className="mindayal-admin-table table-responsive">
							<table className="table">
								<thead>
									<tr>
										<th className="text-nowrap">
											{translationService.translate("TR_NAME") || "Name"}
										</th>
										<th className="text-nowrap">
											{translationService.translate("TR_DESCRIPTION") || "Description"}
										</th>
										<th className="text-nowrap">
											{translationService.translate("TR_ACTIONS") || "Actions"}
										</th>
									</tr>
								</thead>
								<tbody>
									{documents.map((doc, idx) => (
										<tr key={doc.id || idx} style={{ cursor: "default" }}>
											<td className="text-nowrap">
												<Link
													title={doc.name}
													className="text-dark underline word-break-break-word max-line-3"
													to={`/${language}/document/document-view/${doc.id}`}
												>
													{doc.name}
												</Link>
											</td>
											<td>{doc.description}</td>
											<td className="text-nowrap">
												<div
													className="table-action-btn-group d-flex align-items-center course-wrapper--instructor border-none bg-transparent"
													style={{ gap: "5px" }}
												>
													<Link
														className="course-view-button mt-0"
														to={`/${language}/document/document-view/${doc.id}`}
														title={translationService.translate("TR_VIEW") || "View"}>
														<ViewSvg />
													</Link>

													<Link
														className={`course-edit-button mt-0 ${doc.signed ? "disabled" : ""}`}
														to={`/${language}/document/document-form/${doc.id}`}
														title={translationService.translate("TR_EDIT") || "Edit"}>
														<EditSvg />
													</Link>
													<Link
														to={`/${language}/document/subscribe/${doc.id}`}
														className={`course-gamify-button mt-0 ${doc.signed ? "disabled" : ""}`}
														title={
															translationService.translate("TR_DOCUMENT_SUBSCRIPTION") ||
															"Sign"
														}>
														<i className="fa-solid fa-signature" style={{ opacity: doc.signed ? 0.5 : 1 }}></i>
													</Link>
													{/* <a
														href={`${doc.filePath}/download`}
														target="_blank"
														className="course-edit-button mt-0"
														title={translationService.translate("TR_DOWNLOAD") || "Download"}>
														<DownloadSvg />
													</a> */}

													<Link
														className={`course-delet-button mt-0 ${doc.signed ? "disabled" : ""}`}
														to="#"
														title={translationService.translate("TR_DELETE") || "Delete"}
														onClick={e => {
															if (doc.signed) {
																return false;
															}
															e.preventDefault();
															e.stopPropagation();
															onDelete(doc);
														}}
													>
														<DeleteSvg />
													</Link>
												</div>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			) : (
				<div className="no-data-container mt-3">
					<div className="no-data-wrapper">
						<p>{translationService.translate("TR_NO_DATA")}</p>
						<img src={NoDataImage} alt="/" />
					</div>
				</div>
			)}
		</div>
	);
}

export default withRouter(DocumentsTable);
